module.exports = __webpack_public_path__ + "img/BasedowGarten.37d0d41b.svg";